import React from 'react';
import '../styles/contact.css';

function Contact() {
  return (
    <main className="contact-page">
      <div className="contact-container">
        <h1>Contact</h1>
        <div className="contact-content">
          <p>Get in touch for inquiries, commissions, or collaborations.</p>

          <div className="contact-links">
            <a
              href="https://instagram.com/krishisharma"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-link"
            >
              Instagram
            </a>

            <a
              href="mailto:hello@krishisharma.com"
              className="contact-link"
            >
              Email
            </a>
          </div>
        </div>
      </div>
    </main>
  );
}

export default Contact;
